// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2u4Ll","header":"Messages_header__1XjTC"};